import { CfFlowScreen } from '../api/cloudflareFlowApi';

const OFFERS_NEXUS_BUTTON: Readonly<Record<CfFlowScreen, boolean>> = {
  cf_account: true,
  token: true,
  reconnect: true,
  nameservers: true,
  propagation: true,
  progress: true,
  error: true,
  success: false,
  blocked: false,
  abandoned: false,
};

export const offersNexusButton = (screen: CfFlowScreen | null): boolean =>
  screen !== null && OFFERS_NEXUS_BUTTON[screen];
